import api from './api';

const BASE = '/notifies';

export interface SystemNotify {
  id: number;
  title: string;
  message: string | null;
  typ: 'normal' | 'important';
  gelesen: boolean;
  created_at: string;
  link: string | null;
}

export interface SystemNotifySummary {
  unread_count: number;
  has_important: boolean;
  notifies: SystemNotify[];
}

export const notifyService = {
  getOwn: (params?: { only_unread?: boolean; limit?: number }): Promise<SystemNotifySummary> => {
    const searchParams = new URLSearchParams();
    if (params?.only_unread !== undefined) searchParams.set('only_unread', params.only_unread ? '1' : '0');
    if (params?.limit != null) searchParams.set('limit', String(params.limit));
    const qs = searchParams.toString();
    return api.get(`${BASE}/me${qs ? `?${qs}` : ''}`).then((r) => r.data);
  },

  markAsRead: (notifyId: number): Promise<SystemNotify> =>
    api.put(`${BASE}/${notifyId}/gelesen`).then((r) => r.data),

  markAllRead: (): Promise<{ marked: number }> =>
    api.put(`${BASE}/alle-gelesen`).then((r) => r.data),

  create: (data: {
    mitarbeiter_id: number;
    title: string;
    message?: string;
    typ?: 'normal' | 'important';
    link?: string;
  }): Promise<SystemNotify> =>
    api.post(BASE + '/', data).then((r) => r.data),
};
